<template>
	<section
		v-if="!hasActiveEventPass"
		class="l-content-section phygital-plus-info"
	>
		<div class="l-row phygital-plus-info__row">
			<div class="l-col l-col--12 l-col--5@md phygital-plus-info__text-column">
				<div class="phygital-plus-info__content">
					<h2 class="phygital-plus-info__title">
						{{ $I18n.trans('phygital_info.access_banner.title') }}
					</h2>
					<p class="phygital-plus-info__copy">
						{{ $I18n.trans('phygital_info.access_banner.introduction') }}
					</p>
					<p class="phygital-plus-info__copy">
						{{ $I18n.trans('phygital_info.access_banner.description') }}
					</p>
					<div class="phygital-plus-info__passes">
						<div class="phygital-plus-info__pass">
							<h3 class="phygital-plus-info__pass-title">
								{{ $I18n.trans('phygital_info.access_banner.event_pass.title') }}
							</h3>
							<p class="phygital-plus-info__pass-copy">
								{{ $I18n.trans('phygital_info.access_banner.event_pass.copy') }}
							</p>
						</div>
						<div class="phygital-plus-info__pass">
							<h3 class="phygital-plus-info__pass-title">
								{{ $I18n.trans('phygital_info.access_banner.day_pass.title') }}
							</h3>
							<p class="phygital-plus-info__pass-copy">
								{{ $I18n.trans('phygital_info.access_banner.day_pass.copy') }}
							</p>
						</div>
					</div>
					<p class="phygital-plus-info__closing-copy">
						{{ $I18n.trans('phygital_info.access_banner.closing_copy') }}
					</p>
					<Button
						:text="$I18n.trans('phygital_info.access_banner.cta')"
						:link="subscriptionLink"
						theme="dark"
					/>
				</div>
			</div>
			<div class="l-col l-col--12 l-col--6@md l-offset--1@md phygital-plus-info__image-column">
				<img
					class="phygital-plus-info__image"
					src="/images/phygital/astana-2026-access.webp"
					:alt="$I18n.trans('phygital_info.access_banner.image_alt')"
				>
			</div>
		</div>
	</section>
</template>

<script>
import Button from '@shared/components/Button';
import { mapState } from 'vuex';

export default {
	name:       'PhygitalPlusInfo',
	components: { Button },
	data() {
		return {
			subscriptionLink: 'http://astana2026.phygital-plus.com/subscriptions',
		};
	},
	computed: {
		...mapState({
			profile: state => state.user.profile,
		}),
		hasActiveEventPass() {
			return (this.profile?.allResources?.packages || []).some(eventPass => eventPass.isActive);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.phygital-plus-info {
	position: relative;
	margin-bottom: $sp6;

	&::after {
		content: '';
		position: absolute;
		top: 0;
		left: 50%;
		z-index: -1;
		display: block;
		width: 100vw;
		height: 100%;
		background-color: var(--color-grey-900);
		transform: translateX(-50%);
		pointer-events: none;
	}

	&::before {
		// content: '';
		position: absolute;
		top: 0;
		left: 50%;
		display: block;
		width: 100vw;
		height: 4px;
		background-color: var(--color-hype-yellow);
		transform: translateX(-50%);
		pointer-events: none;
	}
}

.phygital-plus-info__row {
	align-items: center;
}

.phygital-plus-info__text-column {
	display: flex;
	align-items: center;
}

.phygital-plus-info__content {
	padding-top: $sp6;
	padding-bottom: $sp6;

	@include size(md-up) {
		padding-top: $sp8-5;
		padding-bottom: $sp8-5;
	}
}

.phygital-plus-info__title {
	@include font(primary, bold, normal, fs-150);

	margin-bottom: $sp4;
	font-family: $font-stack-phygital; // stylelint-disable-line
}

.phygital-plus-info__copy {
	@include font(primary, book, normal, fs-100);

	margin-bottom: $sp4;
	line-height: 1.5;
}

.phygital-plus-info__passes {
	display: grid;
	margin-bottom: $sp4;
	gap: $sp4;
}

.phygital-plus-info__pass {
	padding-left: $sp4;
	border-left-width: 3px;
	border-left-style: solid;
	border-left-color: var(--color-hype-yellow);
}

.phygital-plus-info__pass-title {
	@include font(primary, bold, normal, fs-100);

	margin-bottom: $sp1;
}

.phygital-plus-info__pass-copy {
	@include font(primary, book, normal, fs-100);

	line-height: 1.5;
}

.phygital-plus-info__closing-copy {
	@include font(primary, book, normal, fs-100);

	margin-bottom: $sp5;
	line-height: 1.5;
}

.phygital-plus-info__image-column {
	padding-bottom: $sp6;

	@include size(md-up) {
		padding-top: $sp8-5;
		padding-bottom: $sp8-5;
	}
}

.phygital-plus-info__image {
	display: block;
	width: 100%;
	height: auto;
	border-radius: var(--t-border-radius-card--lg);
}
</style>
